import { useState, useEffect } from 'react';

export const useHighScore = () => {
  const [highScore, setHighScore] = useState<number>(0);
  const [isNewHighScore, setIsNewHighScore] = useState<boolean>(false);

  // Load high score from localStorage when component mounts
  useEffect(() => {
    const savedHighScore = localStorage.getItem('highScore');
    if (savedHighScore) {
      setHighScore(parseInt(savedHighScore, 10));
    }
  }, []);

  // Function to check if current score is a new high score
  const checkHighScore = (currentScore: number) => {
    if (currentScore > highScore) {
      setHighScore(currentScore);
      setIsNewHighScore(true);
      localStorage.setItem('highScore', currentScore.toString());
      return true;
    }
    setIsNewHighScore(false);
    return false;
  };

  // Reset the new high score flag
  const resetNewHighScoreFlag = () => {
    setIsNewHighScore(false);
  };

  return {
    highScore,
    isNewHighScore,
    checkHighScore,
    resetNewHighScoreFlag
  };
};
